/**
 * @module learningContents
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyReportingActions } from '~/behaviors/actions/survey_reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { learningContentActions } from '~/behaviors/actions/learning_content.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const merge = (state, action) => {
  const learningContents = action?.payload?.entities?.learningContents || {};

  Object.values(learningContents).forEach((content) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[content.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[content.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...content,
    };
  });
};

const learningContents = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(learningContentActions.fetchLearningContents.fulfilled, merge);
  builder.addCase(learningContentActions.changeContentEffectiveness.fulfilled, merge);
  builder.addCase(learningContentActions.changeContentCategories.fulfilled, merge);
  builder.addCase(learningContentActions.toggleContentStar.fulfilled, merge);
  builder.addCase(learningContentActions.markContentAsVisited.fulfilled, merge);
  builder.addCase(surveyReportingActions.fetchReportingResults.fulfilled, merge);
  builder.addCase(learningContentActions.rateLearningContent.fulfilled, merge);
});

export default learningContents;
